import $ from 'jquery';
import 'sumoselect';

const sumoSelect = () => {
  const select = $('.js-sumoselect');

  if (!select.length) {
    return;
  }

  select.SumoSelect({
    // nativeOnDevice: [],
  });

  select.on('change', e => {
    const self = $(e.currentTarget);
    const form = self.closest('form');

    if (form.length) {
      form.submit();
    }
  });
};

export default sumoSelect();



// WEBPACK FOOTER //
// ./src/scripts/modules/sumoselect.js